'use client'

import Head from 'next/head'

import User from '@/components/profile/User'
import Password from '@/components/profile/Password'
import Security from '@/components/profile/Security'

const Profile = () => {
  return (
    <>
      <Head>
        <title>Profile</title>
        <meta name="description" content="Profile" />
        <link rel="icon" href="/favicon.ico" />
      </Head>
      <div className="grid grid-cols-4">
        <User className="col-span-4 lg:col-span-2" />
        <Password className="col-span-4 md:col-span-2 2xl:col-span-1" />
        <Security className="col-span-4 md:col-span-2 2xl:col-span-1" />
      </div>
    </>
  )
}

export default Profile
